import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchReports } from '../api/strapi';
import './Hero.css';

export default function Hero() {
  const [latest, setLatest] = useState(null);

  useEffect(() => {
    fetchReports()
      .then((reports) => {
        if (reports.length) {
          setLatest(reports[0]);
        }
      })
      .catch((err) => console.error('Error loading latest report:', err));
  }, []);

  // choose dynamic or fallback
  const bgUrl = latest?.coverUrl;

  return (
    <section
      className="homeHero"
      style={{ backgroundImage: `url(${bgUrl})` }}
    >
      {/* overlayed headline/text */}
      <div className="heroOverlay">
        <div className="heroText">
          <h1 className="title">
            Intelligence from the nexus of business and education
          </h1>
          <p className="subtitle">
            Informing, inspiring, and connecting all sides of the executive education market.
          </p>
        </div>
      </div>

      {/* only show when we have a report */}
      {latest && (
        <div className="heroContentBox">
          <span className="heroContentLabelInline">Latest insights</span>
          <h2 className="heroReportTitle">{latest.headline}</h2>
          <p className="heroReportText">{latest.summary}</p>
          <Link
            to={`/reports/${latest.slug}`}
            className="heroReadMore"
          >
            Read more <i className="fa-regular fa-arrow-right" aria-hidden="true" />
          </Link>
        </div>
      )}
    </section>
  );
}
